import { Component, OnInit } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { NavMenuService, NavRailSection } from './nav-menu.service';

/**
 * Legacy menu host. Dual-nav uses NavMenuService + rail/panel;
 * kept for any residual template references.
 */
@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
  model: NavRailSection[] = [];

  constructor(
    public layoutService: LayoutService,
    private navMenu: NavMenuService
  ) {}

  ngOnInit() {
    this.navMenu.sections$.subscribe(sections => {
      this.model = sections;
    });
  }
}
